import React from "react";
import {listOf, uploadedImageUrl, youtubeIdOf} from "../sectionText";
import {ExpandableYouTubeEmbed} from "../YouTubeEmbed";
import {ANIMAL_IMAGES} from "../../utils";

const MAX_GALLERY_IMAGES = 8;

// Image téléversée depuis l'Admin : le src est revalidé ici (seuls /uploads/landing/<32 hex>.webp sont acceptés).
export function ImageBlock({data}) {
    const src = uploadedImageUrl(data.src);
    if (!src) return null;
    return (
        <figure className="block-image">
            <img src={src} alt={data.decorative === "oui" ? "" : (data.alt || "")} loading="lazy"/>
            {data.caption && <figcaption>{data.caption}</figcaption>}
        </figure>
    );
}

export function GalleryBlock({data}) {
    const images = listOf(data, "items", [])
        .map(item => ({src: uploadedImageUrl(item && item.src), alt: (item && item.alt) || ""}))
        .filter(image => image.src)
        .slice(0, MAX_GALLERY_IMAGES);
    if (images.length === 0) return null;
    return (
        <div className="block-gallery">
            {images.map((image, i) => <img key={i} src={image.src} alt={image.alt} loading="lazy"/>)}
        </div>
    );
}

export function VideoBlock({data}) {
    const videoId = youtubeIdOf(data.video_id, null);
    if (!videoId) return null;
    return <ExpandableYouTubeEmbed videoId={videoId} title={data.title || "Vidéo"}/>;
}

// Défilement lent des illustrations des animaux ; décoratif (masqué aux lecteurs d'écran), liste doublée pour la boucle.
export function AnimalBandBlock() {
    return (
        <div className="block-animal-band" aria-hidden="true">
            <div className="block-animal-band__track">
                {[0, 1].flatMap(copy => ANIMAL_IMAGES.map(animal => (
                    <img key={`${copy}-${animal.name}`} src={animal.image} alt="" loading="lazy"/>
                )))}
            </div>
        </div>
    );
}
